<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <input
      class="form-control"
      type="password"
      [id]="control.key"
      [placeholder]="control.placeholder || control.label"
      [formControlName]="control.key"
      [attr.disabled]="control.disabled ? 'disabled' : null"
    />
  </div>
</div>
